import { trackEvent } from '@patrianna/analytics'
import { nextTick } from '@patrianna/shared-utils'
import { useRouter } from 'next/navigation'

import useBuilderCMSData from 'src/hooks/useBuilderCMSData'
import { useAppSelector } from 'src/store/hooks'
import { sweepstakeEnabledSelector } from 'src/store/modules/appConfig/selectors'

import { WidgetsVariant } from './types'
import type { WidgetBase } from './types'

const PROMO_WIDGET_DATA_MODEL = process.env.CMS_DATA_MODEL_PROMOTIONS_WIDGET

export const usePromoWidget = (): WidgetBase => {
  const router = useRouter()
  const isScEnabled = useAppSelector(sweepstakeEnabledSelector)

  const { builderData: promoData, builderDataLoaded } = useBuilderCMSData(PROMO_WIDGET_DATA_MODEL)

  const builderData = promoData[0]?.data
  const hasBuilderData = !!builderData?.imageUrl && !!builderData?.promoUrl

  const handlePromoClick = () => {
    if (!builderData?.promoUrl) {
      return
    }
    nextTick().then(() => {
      trackEvent('promo_widget_clicked')
      router.push(builderData.promoUrl)
    })
  }

  return {
    id: WidgetsVariant.PROMO,
    isWidgetVisible: isScEnabled && hasBuilderData && builderDataLoaded,
    imgSrc: builderData?.imageUrl,
    imgAlt: builderData?.imageAlt || 'Promo Widget',
    onClick: handlePromoClick,
  }
}
